import { BUSINESS } from "@/data/site";

const base = `https://wa.me/${BUSINESS.whatsappNumber}`;

export function waLink(message) {
  return `${base}?text=${encodeURIComponent(message)}`;
}

export function openWhatsApp(message) {
  window.open(waLink(message), "_blank", "noopener,noreferrer");
}

export const waGeneral = () =>
  waLink(
    `Merhaba ${BUSINESS.name}, hizmetleriniz ve randevu hakkında bilgi almak istiyorum.`
  );

export const waService = (serviceName) =>
  waLink(
    `Merhaba ${BUSINESS.name}, ${serviceName} hakkında bilgi almak ve randevu oluşturmak istiyorum.`
  );

export const waBridal = () =>
  waLink(
    "Merhaba, gelin / nişan / özel gün hazırlığı için görüşme planlamak istiyorum."
  );

export const waRoute = ({ purpose, area, timing }) =>
  waLink(
    `Merhaba ${BUSINESS.name}, Güzellik Rotanı Bul alanından geliyorum. Hazırlık amacım: ${purpose}. İlgilendiğim alan: ${area}. Zaman tercihim: ${timing}. Uygun hizmet ve randevu hakkında bilgi alabilir miyim?`
  );

export const waAppointment = (form) =>
  waLink(
    `Merhaba ${BUSINESS.name}, randevu talebinde bulunmak istiyorum.\n\n` +
      `Ad Soyad: ${form.name || "-"}\n` +
      `Telefon: ${form.phone || "-"}\n` +
      `İlgilendiğim Hizmet: ${form.service || "-"}\n` +
      `Tercih Edilen Gün: ${form.day || "-"}\n` +
      `Tercih Edilen Saat Aralığı: ${form.time || "-"}\n` +
      `Not: ${form.note || "-"}`
  );
